/**
 * Dimension 11 of the assignment block (04-frontend.md §2.1, A1-03): what an assignment row
 * demands of the former contract of the contract under test. ANY is the wildcard value and the
 * column default; WITH only when the contract carries an INTERNAL former contract.
 *
 * Position-based mirror of the backend enum {@code com.mvs.backend.cp.enums.ProvisionFormerContractRequirement}.
 * The backend persists the ordinal (`@Enumerated(EnumType.ORDINAL)`), so the declaration order
 * below MUST match the backend exactly and new constants MUST only be appended at the end — never
 * inserted between existing ones, which would silently re-map every stored value
 * (02-datenmodell.md §0.5/§2).
 */
export enum ProvisionFormerContractRequirement {

    ANY,
    WITH,
    WITHOUT
}
